import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ChatLayout } from './components/chat/ChatLayout';
import { TypewriterPage } from './components/typewriter/TypewriterPage';
import { AuthComplete } from './components/AuthComplete';
import { preloadGradeData } from './services/gradeDescriptionsService';
import { useAuth } from './hooks/useAuth';

/**
 * Onboarding gate component - all users go directly to chat.
 * Splash/typewriter experience is disabled for everyone.
 */
function OnboardingGate() {
  const { user, loading: authLoading, signInAnonymously } = useAuth();

  // Trigger anonymous sign-in if not authenticated
  useEffect(() => {
    if (!user && !authLoading) {
      console.log('🔐 No user - signing in anonymously...');
      signInAnonymously().catch(console.error);
    }
  }, [user, authLoading, signInAnonymously]);

  // Show loading state while checking auth
  if (authLoading || !user) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  // All users go directly to chat
  console.log('🏠 User authenticated - showing chat');
  return <ChatLayout />;
}


function App() {
  const [gradeDataLoaded, setGradeDataLoaded] = useState(false);

  // Preload grade data (K1, K2, K3 mappings) at app start for optimal performance
  useEffect(() => {
    preloadGradeData().then(() => {
      setGradeDataLoaded(true);
    });
  }, []);

  return (
    <Router>
      <Routes>
        {/* Magic link sign-in completion */}
        <Route path="/auth/complete" element={<AuthComplete />} />
        
        {/* Typewriter onboarding - redirects to chat when complete */}
        <Route path="/welcome" element={<TypewriterPage />} />
        
        {/* Direct typewriter access (for testing/debug) */}
        <Route path="/typewriter" element={<TypewriterPage />} />
        
        {/* URL-based conversation routing: /c/:conversationId */}
        <Route path="/c/:conversationId" element={<ChatLayout />} />
        
        {/* Root route - goes through onboarding gate */}
        <Route path="/" element={<OnboardingGate />} />
        
        {/* Catch-all - goes through onboarding gate */}
        <Route path="*" element={<OnboardingGate />} />
      </Routes>
    </Router>
  );
}

export default App;
